// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Jsona } from "jsona";
import { TJsonaModel, TJsonApiBody } from "jsona/lib/JsonaTypes";

type AtomicRef = {
  type: string;
  lid: string;
};

export type AtomicOperation<TData = unknown> = {
  op: "add" | "update" | "remove";
  data: TData;
  ref?: AtomicRef;
};

class ExtendedJsona extends Jsona {
  deserialize(body: Record<string, unknown>) {
    let doc = body?.["atomic:results"] ?? body;

    if (Array.isArray(doc) && doc.every((item) => item?.data !== undefined)) {
      doc = { data: doc.map((item) => item.data) };
    }

    return super.deserialize(doc as TJsonApiBody);
  }
}

export const dataFormatter = new ExtendedJsona();

export const createBody = (data: TJsonaModel | TJsonaModel[]): string =>
  JSON.stringify(dataFormatter.serialize({ stuff: data }));

export const createAtomicOperationsBody = <TData = unknown>(
  operations: AtomicOperation<TData>[]
): string => JSON.stringify({ "atomic:operations": operations });
